import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Icons from "../../icons";
import { Sidebar } from "react-pro-sidebar";
import "./rightSidebar.scss";

const RightSidebar = ({
  isOpen = false,
  children,
  idName = "",
  heading = "",
  collapsedWidth = "40px",
  width = "250px",
  collapseStatus,
}) => {
  const [collapsed, setCollapsed] = useState(!isOpen);

  useEffect(() => {
    setCollapsed(!isOpen);
  }, [isOpen]);

  return (
    <div
      className={
        collapsed
          ? "rightSidebarWraper collapsed"
          : "rightSidebarWraper expanded"
      }
      id={idName}
    >
      <button
        className={classNames("expendCollapsedBtn", { openedIcon: !collapsed })}
        id="expendCollapsedBtn"
        onClick={() => {
          setCollapsed(!collapsed);
          collapseStatus(!collapsed);
        }}
      >
        {collapsed ? Icons.fleetIconCollapsed : Icons.fleetIconExpanded}
      </button>

      <Sidebar
        collapsed={collapsed}
        collapsedWidth={collapsedWidth}
        width={width}
      >
        {collapsed && (
          <h1 className="heading-h1 fleet-color verticalHeading" id="verticalHeading">{heading}</h1>
        )}

        {!collapsed && <div className="contentBody">{children}</div>}
      </Sidebar>
    </div>
  );
};

export default RightSidebar;
